import DynamicFieldsFragment from '@linc-technologies/linced-common/models/dynamic-field/base-fragment';
import type { Type } from '@warp-drive/core/types/symbols';

// Proto: people.EnrolmentMeta.
export default class EnrolmentMeta extends DynamicFieldsFragment {
  declare [Type]: 'people/enrolment-meta';
}
